import { createAsyncReducer } from '@telstra-connect/standard-actions';

import {
    IExportFilesAction,
    IExportFilesSuccessAction,
    IExportFilesErrorAction
} from '../actions/exportFiles';
import { IBillingState } from '../state';
import { initialState } from '../state/initial-state';

export type ExportFilesAction
    = IExportFilesAction
    | IExportFilesSuccessAction
    | IExportFilesErrorAction;

const init = (state: IBillingState, action: ExportFilesAction) => {
    switch (action.exportType) {
        case 'ExportQueriedCharges':
            return {
                ...state,
                exportFiles: {
                    csv: {
                        ...state.exportFiles.csv,
                        exportQueriedCharges: {
                            status: action.status
                        }
                    }
                }
            };
        case 'ExportEnquiries':
            return {
                ...state,
                exportFiles: {
                    csv: {
                        ...state.exportFiles.csv,
                        exportEnquiriesList: {
                            status: action.status
                        }
                    }
                }
            };
        case 'ExportInvoices':
            return {
                ...state,
                exportFiles: {
                    csv: {
                        ...state.exportFiles.csv,
                        exportInvoiceList: {
                            status: action.status
                        }
                    }
                }
            };
        case 'ExportPayments':
            return {
                ...state,
                exportFiles: {
                    csv: {
                        ...state.exportFiles.csv,
                        exportPaymentsList: {
                            status: action.status
                        }
                    }
                }
            };
        case 'ExportCredits':
            return {
                ...state,
                exportFiles: {
                    csv: {
                        ...state.exportFiles.csv,
                        exportCreditList: {
                            status: action.status
                        }
                    }
                }
            };
        case 'DownloadInvoiceSummary':
            return {
                ...state,
                exportFiles: {
                    csv: {
                        ...state.exportFiles.csv,
                        downloadInvoiceSummaryCSV : {
                            status: action.status
                        }
                    }
                }
            };
    }
};

const success = (state: IBillingState, action: ExportFilesAction) => {
    switch (action.exportType) {
        case 'ExportQueriedCharges':
            return {
                ...state,
                exportFiles: {
                    csv: {
                        ...state.exportFiles.csv,
                        exportQueriedCharges: {
                            status: action.status
                        }
                    }
                }
            };
        case 'ExportEnquiries':
            return {
                ...state,
                exportFiles: {
                    csv: {
                        ...state.exportFiles.csv,
                        exportEnquiriesList: {
                            status: action.status
                        }
                    }
                }
            };
        case 'ExportInvoices':
            return {
                ...state,
                exportFiles: {
                    csv: {
                        ...state.exportFiles.csv,
                        exportInvoiceList: {
                            status: action.status
                        }
                    }
                }
            };
        case 'ExportPayments':
            return {
                ...state,
                exportFiles: {
                    csv: {
                        ...state.exportFiles.csv,
                        exportPaymentsList: {
                            status: action.status
                        }
                    }
                }
            };
        case 'ExportCredits':
            return {
                ...state,
                exportFiles: {
                    csv: {
                        ...state.exportFiles.csv,
                        exportCreditList: {
                            status: action.status
                        }
                    }
                }
            };
        case 'DownloadInvoiceSummary':
            return {
                ...state,
                exportFiles: {
                    csv: {
                        ...state.exportFiles.csv,
                        downloadInvoiceSummaryCSV : {
                            status: action.status
                        }
                    }
                }
            };
    }
};

const failure = (state: IBillingState, action: ExportFilesAction) => {
    switch (action.exportType) {
        case 'ExportQueriedCharges':
            return {
                ...state,
                exportFiles: {
                    csv: {
                        ...state.exportFiles.csv,
                        exportQueriedCharges: {
                            status: action.status,
                            error: (action as IExportFilesErrorAction).error,
                            errorCode: (action as IExportFilesErrorAction).errorCode
                        }
                    }
                }
            };
        case 'ExportEnquiries':
            return {
                ...state,
                exportFiles: {
                    csv: {
                        ...state.exportFiles.csv,
                        exportEnquiriesList: {
                            status: action.status,
                            error: (action as IExportFilesErrorAction).error,
                            errorCode: (action as IExportFilesErrorAction).errorCode
                        }
                    }
                }
            }
        case 'ExportInvoices':
            return {
                ...state,
                exportFiles: {
                    csv: {
                        ...state.exportFiles.csv,
                        exportInvoiceList: {
                            status: action.status,
                            error: (action as IExportFilesErrorAction).error,
                            errorCode: (action as IExportFilesErrorAction).errorCode
                        }
                    }
                }
            }
        case 'ExportPayments':
            return {
                ...state,
                exportFiles: {
                    csv: {
                        ...state.exportFiles.csv,
                        exportPaymentsList: {
                            status: action.status,
                            error: (action as IExportFilesErrorAction).error,
                            errorCode: (action as IExportFilesErrorAction).errorCode
                        }
                    }
                }
            }
        case 'DownloadInvoiceSummary':
            return {
                ...state,
                exportFiles: {
                    csv: {
                        ...state.exportFiles.csv,
                        downloadInvoiceSummaryCSV: {
                            status: action.status,
                            error: (action as IExportFilesErrorAction).error,
                            errorCode: (action as IExportFilesErrorAction).errorCode
                        }
                    }
                }
            };
        case 'ExportCredits':
            return {
                ...state,
                exportFiles: {
                    csv: {
                        ...state.exportFiles.csv,
                        exportCreditList: {
                            status: action.status,
                            error: (action as IExportFilesErrorAction).error,
                            errorCode: (action as IExportFilesErrorAction).errorCode
                        }
                    }
                }
            };
    }
}
export const exportFilesReducer = createAsyncReducer(initialState, init, success, failure);
